/**
 * Parse API error bodies (TrafficPulse envelope + flat Nest shapes).
 * For Media Devoted | Created By Ciro Autiero
 */

function isRecord(v: unknown): v is Record<string, unknown> {
  return v !== null && typeof v === 'object' && !Array.isArray(v);
}

function normalizeMessageField(msg: unknown): string | null {
  if (typeof msg === 'string') {
    const t = msg.trim();
    return t.length > 0 ? t : null;
  }
  if (!Array.isArray(msg)) return null;
  const parts = msg
    .filter((x): x is string => typeof x === 'string')
    .map((s) => s.trim())
    .filter(Boolean);
  return parts.length > 0 ? parts.join('; ') : null;
}

function responseDataFromError(error: unknown): unknown {
  if (!isRecord(error)) return undefined;
  const resp = error.response;
  if (!isRecord(resp)) return undefined;
  return resp.data;
}

/**
 * User-facing text from API/axios errors. Prefer backend body over generic Axios text.
 */
export function getApiErrorMessage(error: unknown, fallback = 'An error occurred'): string {
  const data = responseDataFromError(error);
  if (isRecord(data)) {
    const nested = data.error;
    if (isRecord(nested)) {
      const fromEnvelope = normalizeMessageField(nested.message);
      if (fromEnvelope) return fromEnvelope;
    }
    const fromFlat = normalizeMessageField(data.message);
    if (fromFlat) return fromFlat;
  }
  if (error instanceof Error && error.message.trim()) return error.message;
  if (isRecord(error) && typeof error.message === 'string') {
    const t = error.message.trim();
    if (t) return t;
  }
  return fallback;
}
